<script>
const weight_List = [
  {
    value: 10,
    label: 10,
  },
  {
    value: 9,
    label: 9,
  },
  {
    value: 8,
    label: 8,
  },
  {
    value: 7,
    label: 7,
  },
  {
    value: 6,
    label: 6,
  },
  {
    value: 5,
    label: 5,
  },
  {
    value: 4,
    label: 4,
  },
  {
    value: 3,
    label: 3,
  },
  {
    value: 2,
    label: 2,
  },
  {
    value: 1,
    label: 1,
  },
  {
    value: 0,
    label: 0,
  },
]
const option = [
  {
    value: '1',
    label: '下拉',
  },
]
const room = [
  {
    value: 0,
    label: 0,
  },
  {
    value: 1,
    label: 1,
  },
  {
    value: 2,
    label: 2,
  },
  {
    value: 3,
    label: 3,
  },
  {
    value: 4,
    label: 4,
  },
  {
    value: 5,
    label: 5,
  },
]

const cascader = [
  {
    value: 'beijing',
    label: '北京',
    children: [],
    loading: false,
  },
  {
    value: 'hangzhou',
    label: '杭州',
    children: [],
    loading: false,
  },
]

export default {
  weight_List, //权重列表
  option, //下拉
  cascader, //地区选择
  room, //户型
}
</script>


// WEBPACK FOOTER //
// src/components/global/global.vue